import { createMuiTheme, Theme } from '@material-ui/core';
import { colors, MUIComponentsTheme } from '@lifesize/clients.mui-components';
import AzoRegular from '@lifesize/clients.mui-components/lib/fonts/RuiAbreu-AzoSans-Regular.woff2';
import AzoRegularWoff from '@lifesize/clients.mui-components/lib/fonts/azo-sans-web.woff';
import _merge from 'lodash/merge';

const azo = {
  fontFamily: 'azo-sans-web',
  fontStyle: 'normal',
  fontWeight: 400,
  fontDisplay: 'swap',
  src: `
    local('azo-sans-web'),
    url(${AzoRegular}) format('woff2'),
    url(${AzoRegularWoff}) format('woff')
  `
};

const fontFamilyPrimary = 'azo-sans-web';

MUIComponentsTheme.typography.fontFamily = 'azo-sans-web';
MUIComponentsTheme.palette.background.default = colors.white;
MUIComponentsTheme.overrides = _merge(MUIComponentsTheme.overrides, {
  MuiCssBaseline: {
    '@global': {
      '@font-face': [azo],
      '.MuiContainer-root': {
        display: 'flex',
        padding: 0
      },
      '.noOffice': {
        maxWidth: 400,
        position: 'relative'
      }
    }
  },
  MuiButton: {
    root: {
      fontFamily: fontFamilyPrimary
    }
  },
  MuiCheckbox: {
    colorSecondary: {
      color: colors.lifesize,
      '&.Mui-checked': {
        color: colors.lifesize
      }
    }
  },
  MuiFormLabel: {
    root: {
      fontFamily: fontFamilyPrimary,
      letterSpacing: '0.07px',
      '&.Mui-focused': {
        color: colors.black
      }
    }
  },
  MuiRadio: {
    colorSecondary: {
      color: colors.lifesize,
      '&.Mui-checked': {
        color: colors.lifesize
      }
    }
  },
  MuiInput: {
    root: {
      maxWidth: '500px'
    }
  },
  MuiInputBase: {
    root: {
      fontFamily: fontFamilyPrimary
    }
  },
  MuiTooltip: {
    tooltip: {
      maxWidth: 220,
      textAlign: 'center'
    }
  },
  MuiTextField: {
    root: {
      '& input': {
        fontFamily: fontFamilyPrimary
      }
    }
  },
  MuiTypography: {
    root: {
      fontFamily: fontFamilyPrimary
    },
    body1: {
      fontFamily: fontFamilyPrimary,
      fontSize: '1.4rem'
    },
    button: {
      fontFamily: fontFamilyPrimary
    },
    h1: {
      fontFamily: fontFamilyPrimary,
      fontSize: '2rem'
    },
    h2: {
      fontFamily: fontFamilyPrimary
    },
    h3: {
      fontFamily: fontFamilyPrimary,
      fontSize: '1.5rem',
      fontWeight: 600
    },
    h4: {
      fontFamily: fontFamilyPrimary
    },
    subtitle1: {
      fontFamily: fontFamilyPrimary
    },
    subtitle2: {
      fontFamily: fontFamilyPrimary
    }
  },
  MuiSnackbarContent: {
    root: {
      justifyContent: 'center'
    }
  },
  MuiAutocomplete: {
    root: {
      '& .MuiAutocomplete-popupIndicatorOpen': {
        transform: 'none'
      },
      '& .MuiAutocomplete-popupIndicator:hover': {
        backgroundColor: 'transparent'
      },
      '& .searchIcon': {
        height: 20,
        fill: colors.neutralGray
      },
      '& fieldset': {
        borderColor: colors.stone,
        borderRadius: '2px',
        borderWidth: '2px'
      },
      '& .MuiInputBase-root:hover': {
        '& fieldset': {
          borderColor: colors.lifesize
        }
      },
      '& input::-ms-clear': {
        display: 'none'
      }
    }
  }
});

export const theme: Theme = createMuiTheme(MUIComponentsTheme);
